import { getObjectKeysAsObject } from "@checkout/helpers";
import {
  trackAddContactEvent,
  trackViewContactInformation,
} from "@checkout/tracking/contactInformation";

/**
 * The contact step leaves `saving` only once this settles, and its `onError`
 * targets are identical to `onDone` — so awaiting delivery gates checkout on an
 * analytics request without ever changing where the customer goes. A POST that
 * never settles (a suspended WebView drops in-flight XHRs silently) would strand
 * them on the contact form for the rest of the session, so the event is fired
 * without being awaited.
 */
const trackAddContactEventWithoutBlocking = async (
  ...args: Parameters<typeof trackAddContactEvent>
) => {
  trackAddContactEvent(...args).catch(() => undefined);
};

export const services = {
  trackViewContactInformation,
  trackAddContactEvent: trackAddContactEventWithoutBlocking,
};

export const ServiceTypes = getObjectKeysAsObject(services);
